import React from 'react';
import { useGetCareNow } from '~/components/CareTeam/hooks/useGetCareNow';
import { analyticsTrackEvent } from '~/core/analytics';
import { DRAWER_TYPE_FALL_ALLERGIES, NAV_TILE_CLICKED } from '~/core/analytics/events';
import { useTrackNavTile } from '../../hooks/useTrackNavTile';
import { Details, Icon, Root, SubTitle, Title } from '../../styles';
import dataTestIds from '~/test/test-ids';
import { isUserProfileAMinor } from '~/core/util/userProfile';
import useSelectActiveUserProfile from '~/hooks/useSelectActiveUserProfile';

export const BookFallAllergyTreatment = () => {
  const goToGetCare = useGetCareNow('uc');

  const onClick = () => {
    goToGetCare();
    analyticsTrackEvent(NAV_TILE_CLICKED, {
      type: DRAWER_TYPE_FALL_ALLERGIES,
    });
  };
  const isMinor = isUserProfileAMinor(useSelectActiveUserProfile());

  useTrackNavTile('fall-allergies');

  return (
    <Root onClick={onClick}>
      <Icon
        alt="Illustration of fall leaves"
        src="/images/account/essentialFallServices/fall_allergy.svg"
      />
      <Details>
        <Title>Fall allergies</Title>
        <SubTitle>Manage your {isMinor && `kids' `}symptoms this season</SubTitle>
      </Details>
    </Root>
  );
};
